import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehicleManagementComponent } from './vehicle-management.component';
import { VehicleManagementRoutingModule } from './vehicle-management-routing.module';
import { AddVehicleFormComponent } from './add-vehicle-form/add-vehicle-form.component';
import { SharedModule } from '../../shared/shared.module';
import { FleetAppointmentComponent } from './fleet-appointment/fleet-appointment.component';
import { EditLicensePlateComponent } from './edit-license-plate/edit-license-plate.component';
import { DeletePendingComponent } from './delete-pending/delete-pending.component';


@NgModule({
  declarations: [VehicleManagementComponent,AddVehicleFormComponent, FleetAppointmentComponent, EditLicensePlateComponent, DeletePendingComponent],
  imports: [
    CommonModule,
    SharedModule,
    VehicleManagementRoutingModule
  ]
})
export class VehicleManagementModule { }
